import Output from './Output';

export default Output;